export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const CIGAR_PLACEHOLDER = 'https://customer-assets.emergentagent.com/job_4d4080af-0cc5-471d-bc86-4e4bd2f38c46/artifacts/xfkvm02p_splash.png';
